import { createAction, props } from '@ngrx/store';

export const showDialogMessage = createAction(
  '[Core/DialogMessage] Show Dialog Message',
  props<{
    image?: string;
    disableClose?: boolean;
    message: {
      title: string;
      content: string;
    };
    actions?: { primaryAction?: { label: string; handler: () => void } };
  }>(),
);
export const showDialog = createAction(
  '[Core/DialogMessage] Show Dialog',
  props<{
    modalType: string;
    payload: any;
  }>(),
);

export const closeDialogMessage = createAction(
  '[Core/DialogMessage] Closed Dialog Message',
);
